module.exports = __webpack_public_path__ + "img/28.31978a5f.png";